"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingStatusChangedEvent = exports.SetOnboardingStatusCommand = void 0;
const cq_core_1 = require("@leavy/cq-core");
const validator_1 = require("@leavy/validator");
const base_1 = require("../../base");
const domain_events_core_1 = require("@leavy/domain-events-core");
const UserOnboardingStatus_1 = require("../domain/UserOnboardingStatus");
const BaseOnboardingCommand_1 = require("./BaseOnboardingCommand");
let SetOnboardingStatusCommand = class SetOnboardingStatusCommand extends BaseOnboardingCommand_1.BaseOnboardingCommand {
};
__decorate([
    (0, validator_1.IsEnum)(UserOnboardingStatus_1.UserOnboardingStatus),
    __metadata("design:type", String)
], SetOnboardingStatusCommand.prototype, "status", void 0);
SetOnboardingStatusCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "set_onboarding_status",
    })
], SetOnboardingStatusCommand);
exports.SetOnboardingStatusCommand = SetOnboardingStatusCommand;
let OnboardingStatusChangedEvent = class OnboardingStatusChangedEvent extends domain_events_core_1.DomainEventBase {
    constructor(data) {
        super(data);
    }
};
__decorate([
    (0, domain_events_core_1.EventProperty)(),
    __metadata("design:type", String)
], OnboardingStatusChangedEvent.prototype, "userId", void 0);
__decorate([
    (0, domain_events_core_1.EventProperty)(),
    __metadata("design:type", String)
], OnboardingStatusChangedEvent.prototype, "onboardingId", void 0);
__decorate([
    (0, domain_events_core_1.EventProperty)({ optional: true }),
    __metadata("design:type", String)
], OnboardingStatusChangedEvent.prototype, "oldStatus", void 0);
__decorate([
    (0, domain_events_core_1.EventProperty)(),
    __metadata("design:type", String)
], OnboardingStatusChangedEvent.prototype, "newStatus", void 0);
OnboardingStatusChangedEvent = __decorate([
    (0, domain_events_core_1.DomainEvent)({ namespace: base_1.ONBOARDING_SERVICE_NAME, name: "onboarding_status_changed", version: 1 }),
    __metadata("design:paramtypes", [Object])
], OnboardingStatusChangedEvent);
exports.OnboardingStatusChangedEvent = OnboardingStatusChangedEvent;
//# sourceMappingURL=SetOnboardingStatusCommand.js.map